import { DateRange } from "react-day-picker";

import { FilterBuilderInputMode } from "../types";

import BetweenNumberValueInput from "./BetweenNumberValueInput";
import DateValueInput from "./DateValueInput";
import TextValueInput from "./TextValueInput";

interface ValueInputRouterProps {
  mode: FilterBuilderInputMode;
  inputRef: React.RefObject<HTMLInputElement | null>;
  value: string;
  textPlaceholder: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus: () => void;
  onBlur: () => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  dateValue: DateRange | undefined;
  onDateChange: (nextDate: DateRange | undefined) => void;
  onDateApply: () => void;
  canApplyDateValue: boolean;
}

const ValueInputRouter = ({
  mode,
  inputRef,
  value,
  textPlaceholder,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  dateValue,
  onDateChange,
  onDateApply,
  canApplyDateValue,
}: ValueInputRouterProps) => {
  switch (mode) {
    case FilterBuilderInputMode.Date:
      return (
        <DateValueInput
          date={dateValue}
          onChange={onDateChange}
          onApply={onDateApply}
          canApply={canApplyDateValue}
          singleDateSelection
        />
      );

    case FilterBuilderInputMode.DateRange:
      return (
        <DateValueInput
          date={dateValue}
          onChange={onDateChange}
          onApply={onDateApply}
          canApply={canApplyDateValue}
        />
      );

    case FilterBuilderInputMode.BetweenNumber:
      return (
        <BetweenNumberValueInput
          inputRef={inputRef}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
        />
      );

    case FilterBuilderInputMode.BetweenCost:
      return (
        <BetweenNumberValueInput
          inputRef={inputRef}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          type="text"
          inputMode="decimal"
          minPlaceholder="$0.0001"
          maxPlaceholder="$0.001"
          allowCurrencyPrefix
        />
      );

    case FilterBuilderInputMode.BetweenLatency:
      return (
        <BetweenNumberValueInput
          inputRef={inputRef}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          type="text"
          inputMode="decimal"
          minPlaceholder="e.g. 100ms"
          maxPlaceholder="e.g. 1.5s"
          allowUnitSuffix
        />
      );

    case FilterBuilderInputMode.Cost:
      return (
        <TextValueInput
          inputRef={inputRef}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          placeholder="$0.0003"
          inputMode="decimal"
          sanitizeNumeric
          allowCurrencyPrefix
        />
      );

    case FilterBuilderInputMode.Latency:
      return (
        <TextValueInput
          inputRef={inputRef}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          placeholder="e.g. 1.5s, 2m"
          inputMode="decimal"
          sanitizeNumeric
          allowUnitSuffix
        />
      );

    case FilterBuilderInputMode.None:
      return null;

    default:
      return (
        <TextValueInput
          inputRef={inputRef}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          placeholder={textPlaceholder}
          sanitizeNumeric={FilterBuilderInputMode.Number === mode}
        />
      );
  }
};

export default ValueInputRouter;
